module.exports = __webpack_public_path__ + "static/img/YsmLOGO.47437a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YsmLOGO.png
// module id = wMBW
// module chunks = 1